import clsx from "clsx";
import React, { useCallback } from "react";

interface NetworkElementInputRowProps {
  portInfo: any;
  onPortNameChange: (portTempId: number, portName: string) => void;
  onKeypress: (_: any) => void;
  isValidPortName: ((portName: string) => boolean) | undefined;
}

const NetworkElementInputRow: React.FC<NetworkElementInputRowProps> = ({ portInfo, isValidPortName, onPortNameChange, onKeypress }) => {
  const handlePortNameChange = useCallback(
    (e: any) => {
      onPortNameChange(portInfo.id, e.target.value);
    },
    [portInfo, onPortNameChange]
  );

  const error = isValidPortName ? !isValidPortName(portInfo.portName) : false;
  return (
    <div className="input-row">
      <div>
        <div>
          <input
            name={portInfo.portName}
            className={clsx("port-name d-input", error && "d-input-error")}
            value={portInfo.portName}
            onChange={handlePortNameChange}
            onKeyPress={onKeypress}
          />
          {error && <label className={clsx("d-error")}>{`${portInfo.portName} already exists.`}</label>}
        </div>
      </div>
    </div>
  );
};

export default NetworkElementInputRow;
